<section>
  <h1 class="header-1">{{ 'registration-complete.title' | translate }}</h1>
  <p>{{ 'registration-complete.content' | translate }}</p>
</section>